import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './features/auth/AuthProvider';
import { useToast } from './hooks/useToast';

import DashboardLayout from './components/layout/DashboardLayout';
// Layouts
import PublicLayout from './components/layout/PublicLayout';

import EventPublicPage from './pages/EventPublicPage';
import EventsListPage from './pages/EventsListPage';
// Pages - Public
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

import EventAnalyticsPage from './pages/EventAnalyticsPage';
import ReportsPage from './pages/ReportsPage';
import AttendeesPage from './pages/dashboard/AttendeesPage';
import CheckInPage from './pages/dashboard/CheckInPage';
import CreateEventPage from './pages/dashboard/CreateEventPage';
// Pages - Dashboard (Organizadores)
import DashboardHomePage from './pages/dashboard/DashboardHomePage';
import EditEventPage from './pages/dashboard/EditEventPage';
import EventDashboardPage from './pages/dashboard/EventDashboardPage';
import MapEditorPage from './pages/dashboard/MapEditorPage';
import MyEventsPage from './pages/dashboard/MyEventsPage';
import PendingPaymentsPage from './pages/dashboard/PendingPaymentsPage';
import TreasuryHubPage from './pages/dashboard/TreasuryHubPage';
import UsersManagementPage from './pages/dashboard/UsersManagementPage';

// Pages - Checkout
import CheckoutPage from './pages/CheckoutPage';
import MyPurchasesPage from './pages/MyPurchasesPage';
import PurchaseConfirmationPage from './pages/PurchaseConfirmationPage';

function App() {
  const { ToastContainer } = useToast();

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/eventos" element={<EventsListPage />} />
            <Route path="/eventos/:id" element={<EventPublicPage />} />
            {/* Conveniencia: redirigir /events/new a la ruta del dashboard */}
            <Route path="/events/new" element={<Navigate to="/dashboard/events/new" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/compra/:id" element={<PurchaseConfirmationPage />} />
            <Route path="/mis-compras" element={<MyPurchasesPage />} />
          </Route>

          {/* Rutas del dashboard (organizadores) */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHomePage />} />
            <Route path="events" element={<MyEventsPage />} />
            <Route path="events/new" element={<CreateEventPage />} />
            <Route path="events/:id" element={<EventDashboardPage />} />
            <Route path="events/:id/edit" element={<EditEventPage />} />
            <Route path="events/:id/map" element={<MapEditorPage />} />
            <Route path="events/:id/analytics" element={<EventAnalyticsPage />} />
            <Route path="events/:id/attendees" element={<AttendeesPage />} />
            <Route path="events/:id/checkin" element={<CheckInPage />} />
            <Route path="events/:id/payments" element={<PendingPaymentsPage />} />
            <Route path="payments" element={<TreasuryHubPage />} />
            <Route path="users" element={<UsersManagementPage />} />
            <Route path="reports" element={<ReportsPage />} />
          </Route>
        </Routes>
        <ToastContainer />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
